<style lang="less" scoped>
  .order-cover {
    background-color: #ffffff;
      .order-list-cover {
        border: solid 1px #d9dde8;
        border-radius: 4px;
        margin-bottom: 16px;
      }
      .order-list-ceil {
        width: 100%;
        padding: 12px 16px;
        border-bottom: solid 1px #d9dde8;
        display: flex;
        .order-list-title {
          flex: 1
        }
        .order-list-delete {
          display: flex;
          flex: 1;
          justify-content: flex-end;

          .order-list-delete-btn {
            width: 40px;
            padding: 0;
            border: none;
            display: flex;
            justify-content: center;
            img {
              width: 16px;
            }
          }
        }
      }
      .order-list {
        .order-list-content {
          padding: 0 16px;
          border-bottom: 1px solid #d9dde8;
          > div {
            margin: 4px 0;
          }
          .present-add-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            color: #8492a6;
            padding: 16px 0;
            img {
              width: 20px;
              height: 20px;
              margin-right: 5px;
            }
          }
        }
      }
    }
    .order-info-compute {
      padding: 0 16px;

      .order-info-row {
        display: flex;
        padding: 8px 0;
        > div:nth-of-type(1) {
          display: flex;
          flex: 1;
          align-items: center;
        }
        > div:nth-of-type(2) {
          width: 120px;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  .add-recipe-type-dialog {
    .el-dialog {
      .el-dialog__header {
        display: none !important;
      }
    }
  }
</style>

<template lang="pug">
  .order-list-cover
    .order-list
      .order-list-ceil
        strong.order-list-title {{prescription.name}}
        .order-list-delete
          // 처방 삭제
          el-button.order-list-delete-btn(@click="deletePrescription")
            img(src="@/assets/trash-red-small@2x.png")
      .order-list-content
        // 약재 갯수 설정 폼
        present-component(
          v-for="(ingredient, key, index) in prescription.ingredients",
          v-bind:ingredient="ingredient",
          @deleteIngredient="deleteIngredient(ingredient, $event)",
          @update="updateIngredientData($event)")
        // 약재 선택 다이얼로그 오픈 버튼
        .present-add-btn(@click="selectIngredientList(prescription.ingredients)")
          img(src="@/assets/add-circle-gray@2x.png")
          span 약재 추가
      .order-info-compute
        .order-info-row
          .order-info-title 첩당 가격
          strong &#8361;{{(Math.round(pricePerUnit * 100) / 100).toLocaleString()}}원
        .order-info-row
          .order-info-title 첩수
          div
            el-input-number(controls-position="right" v-model="prescription.units" :min="1")
        .order-info-row
          .order-info-title 팩수
          div
            el-input-number(controls-position="right" v-model="prescription.packs" :min="1")
        .order-info-row
          .order-info-title 약재비
          strong &#8361;{{medicinePrice.toLocaleString()}}원
        .order-info-row
          .order-info-title 탕전비
          strong &#8361;10,000원
        .order-info-row
          .order-info-title 조제비
          strong &#8361;5,000원
        .order-info-row
          .order-info-title 합계
          strong &#8361;{{totalprice.toLocaleString()}}원
</template>

<script>
import presentComponent from '@/components/present';

export default {
  props: ['prescription', 'delivery'],
  methods: {
    deleteIngredient(obj, simple) {
      const index = this.prescription.ingredients.findIndex(ingredient => ingredient === obj);
      if (index !== -1) {
        this.prescription.ingredients.splice(index, 1);
      }
      /* 총 합계 계산용 배열에서 이 약재만 삭제한다. */
      const findIdx = this.ingredientDataArr.findIndex(ingredient => ingredient.id === simple.id);
      if (findIdx !== -1) {
        this.ingredientDataArr.splice(findIdx, 1);
      }
    },
    deletePrescription() {
      this.$emit('remove');
    },
    openDialog(dialog) {
      this.$emit('openDialog', dialog);
    },
    selectIngredientList(refObj) {
      this.openDialog(3);
      this.$emit('selectIngredientList', refObj);
    },
    updateIngredientData(data) {
      const index = this.ingredientDataArr.findIndex(element => element.id === data.id);
      if (index === -1) {
        this.ingredientDataArr.push(data);
      } else {
        this.ingredientDataArr[index].amount = data.amount;
      }
    },
  },
  components: {
    presentComponent,
  },
  watch: {
    totalprice() {
      this.prescription.totalprice = this.totalprice;
    },
  },
  computed: {
    totalprice() {
      let result = 0;
      result += this.medicinePrice;
      result += 15000; // 탕전비(10000) + 조제비(5000)
      return Math.floor(result / 10) * 10;
    },
    medicinePrice() {
      let result = 0;
      const defaultPrice = this.prescription.ingredients.length > 0 ? 17000 : 0;
      const morePacks = (this.prescription.packs - 30) < 0 ? 0 : this.prescription.packs - 30;
      result += (this.pricePerUnit * this.prescription.units); // 첩당 가격 * 첩 수
      result += defaultPrice; // 기본료
      result += morePacks * 150; // 30팩 이후 가격 150원씩 추가
      return result;
    },
    pricePerUnit() {
      let result = 0;
      this.ingredientDataArr.forEach((element) => {
        const price = element.price;
        const amount = element.amount;
        result += price * amount;
      });
      return result;
    },
  },
  data() {
    return {
      cnt: 1,
      ingredientDataArr: [],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/present_form.vue